<script setup>
    import {globalStore} from "@pinia/global-store";
    import {objNotEmpty} from "@util/mixins";
    import {handlePredictiveUrl, setPredictiveResult} from "@util/api";
    import {ref} from "vue";

    import SearchButton from "@component/SearchButton/SearchButton.vue";
    import PredictiveDropdown from "@component/PredictiveDropdown/PredictiveDropdown.vue";

    const {predictiveApi,} = API;
    const {dropdownNoResults} = GLOBAL

    const {
        enrollingTrialsLink,
        matchTrialLink,
        menu,
        menuText,
        menuSearchText,
        postId,
        searchLabel,
        searchPlaceholder,
        trialsBtnText,
    } = NAV;

    const {searchUrl} = globalStore();
    const searchedItem = ref({});

    /**
     * Determines if a menu item is active or not
     * @param {Number} postId
     * @param id
     * @returns {string}
     */
    const isActive = (postId, id) => postId === id ? 'active' : ''

    /**
     * Take the user directly to the page if it is a generated
     * result, or take the user to the Search page if it is
     * a search term
     *
     * @param {String} name The name of the selected item
     * @param {String} url  The URL of the selected item
     */
    const goToLink = ({name, url}) => handlePredictiveUrl({name, url})
</script>

<template>
    <div>
        <button
            class="btn-trials"
            aria-controls="trial-dd"
            aria-haspopup="true"
            aria-expanded="false"
            v-html="trialsBtnText"
        />

        <div
            id="trial-dd"
            aria-hidden="true"
            class="megamenu">
            <!-- Back Button -->
            <div class="back-btn">
                <a
                    href="#"
                    class="back"
                >
                    <span />
                    {{ menuText }}
                </a>
            </div>

            <form
                role="search"
                method="get"
                ref="navForm"
                :action="searchUrl"
            >
                <!-- Content before the input field -->
                <div class="form-top">
                    <label
                        for="nav-trials-search"
                        v-text="searchLabel"
                    />
                    <ul v-if="objNotEmpty(enrollingTrialsLink) || objNotEmpty(matchTrialLink)">
                        <li v-if="objNotEmpty(enrollingTrialsLink)">
                            <a
                                :href="enrollingTrialsLink?.url"
                                :target="enrollingTrialsLink?.target"
                                v-text="enrollingTrialsLink?.title"
                            />
                        </li>
                        <li v-if="objNotEmpty(matchTrialLink)">
                            <a
                                :href="matchTrialLink?.url"
                                :target="matchTrialLink?.target"
                                v-text="matchTrialLink?.title"
                            />
                        </li>
                    </ul>
                </div>

                <div class="form-body">
                    <PredictiveDropdown
                        id="nav-trials-search"
                        label="name"
                        :api="predictiveApi"
                        :placeholder="searchPlaceholder"
                        :noResults="dropdownNoResults"
                        @getResult="goToLink"
                    />
                    <SearchButton
                        :button-text="menuSearchText"
                        @clickAction="setPredictiveResult(searchedItem)"
                    />
                </div>

                <div
                    v-if="menu.trials.length"
                    class="form-footer"
                >
                    <div class="row">
                        <ul
                            v-for="(item, index) in menu.trials"
                            :key="index"
                            class="col-6"
                        >
                            <li
                                v-if="objNotEmpty(item)"
                                v-for="(menuItem) in item"
                                :key="menuItem.id"
                            >
                                <a
                                    :href="menuItem.permalink"
                                    :class="`${menuItem.classes} ${isActive(postId, menuItem.objId)}`"
                                    :target="menuItem.target">
                                    {{ menuItem.title }}
                                    <span />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </form>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Navigation Search"
    }
</script>

<style lang="scss" scoped>
    .dropdown__container {
        position: relative;
        min-height: 100px;
    }
    .form-body {
        .vs__dropdown-menu {
            max-height: fit-content;
        }
    }
</style>
